import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { MyDocsService } from '../../service/mydocs.service';
import { MyDocsModel } from '../../models/upload/mydocs.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';

@Component({
  selector: 'app-add-commission-doc',
  templateUrl: './add-commission-doc.component.html',
  styleUrls: ['./add-commission-doc.component.css']
})
export class AddCommissionDocComponent implements OnInit {

  selectedFiles: FileList;
  currentFile: File;
  progress = 0;
  message = '';


  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public salesChannel: string;
  public commPlanDescData: MyDocsModel[] = [];
  public salesChannelsData: MyDocsModel[] = [];

  fileInfos: Observable<any>;

  public myDocsModel = new MyDocsModel();
  constructor(private router: Router, private myDocsService: MyDocsService,
    private authGaurdService: AuthGaurdService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.getSalesChannelsList();
    this.getCommPlanList();
  }

  public getSalesChannelsList(): void {

    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getSalesChannelsList().subscribe(
        (response: MyDocsModel[]) => {
          this.salesChannelsData = response;
          this.refreshing = false;
          this.getCommPlanList();
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }
  public getCommPlanList(): void {
    this.salesChannel = this.myDocsModel.salesChannelDesc;
    console.log(this.salesChannel);
    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getCommPlanList(this.salesChannel).subscribe(
        (response: MyDocsModel[]) => {
          this.commPlanDescData = response;
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  uploadDocs() {
    console.log("selectedFiles = " + this.selectedFiles);
    console.log("doc_name = " + this.myDocsModel.doc_name);
    console.log("doc_desc = " + this.myDocsModel.doc_desc);
    console.log("comm_plan_id = " + this.myDocsModel.comm_plan_id);
    console.log("salesChannelDesc = " + this.myDocsModel.salesChannelDesc);

    if (this.myDocsModel.doc_name === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Enter Document Name!');
    } else if (this.myDocsModel.doc_desc === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Enter Document Description!');
    } else if (this.myDocsModel.effective_dt === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Select Effective Date!');
    } else if (this.myDocsModel.salesChannelDesc === "" || this.myDocsModel.salesChannelDesc === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Select Sales Channel!');
    } else if (this.myDocsModel.comm_plan_id === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Select Commission Plan!');
    } else if (this.selectedFiles === undefined) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Choose File !');
    } else {

      this.progress = 0;
      this.currentFile = this.selectedFiles.item(0);
      console.log("this.currentFile = " + this.currentFile);
      this.myDocsService.uploadDocs(this.currentFile, this.myDocsModel.doc_name, this.myDocsModel.doc_desc, this.myDocsModel.comm_plan_id,this.myDocsModel.effective_dt).subscribe(
        event => {
          this.myDocsModel.doc_name = "";
          this.myDocsModel.doc_desc = "";
          this.myDocsModel.comm_plan_id = "";
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Uploaded Successfully');
          this.router.navigate(['/user-doc-mapping']);
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            this.message = event.body.message;
            //this.fileInfos = this.myDocsService.getFiles();
          }
        },
        err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Could not upload the file!');
          this.progress = 0;
          this.message = 'Could not upload the file!';
         // this.currentFile = undefined;
        });

      this.selectedFiles = undefined;
    }
  }



  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    console.log('evt=== ', evt);
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }
}
